import React from 'react';
import Seo from '../components/Seo';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import ChildCareOutlinedIcon from '@mui/icons-material/ChildCareOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import ElderlyWomanOutlinedIcon from '@mui/icons-material/ElderlyWomanOutlined';
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import { Link } from 'react-router-dom';

const programmes = [
  {
    name: 'Advice Services',
    icon: <InfoOutlinedIcon fontSize="large" style={{ color: '#7b1e3a' }} />,
    desc: 'Free, confidential advice in many areas for the Crumlin Road community.',
    path: '/advice-services'
  },
  {
    name: 'Afterschools Play Club',
    icon: <SchoolOutlinedIcon fontSize="large" style={{ color: '#e67c30' }} />,
    desc: 'A wide range of activities for children aged 4-11, including school pick-up and care until 6pm.',
    path: '/afterschools'
  },
  {
    name: 'Bulrush Day Nursery',
    icon: <ChildCareOutlinedIcon fontSize="large" style={{ color: '#b48a78' }} />,
    desc: 'Affordable, accessible childcare and a safe, stimulating environment for children.',
    path: '/bulrush-nursery'
  },
  {
    name: 'Family Education, Training and Employability',
    icon: <Diversity3OutlinedIcon fontSize="large" style={{ color: '#7b1e3a' }} />,
    desc: 'Learning opportunities for all ages, from job skills to helping with homework.',
    path: '/education-training'
  },
  {
    name: 'Senior Citizens Lunch Club',
    icon: <ElderlyWomanOutlinedIcon fontSize="large" style={{ color: '#3a6c5a' }} />,
    desc: 'A weekly club for older adults to enjoy company, activities, and a meal.',
    path: '/senior-citizens'
  },
  {
    name: 'Pastoral Care',
    icon: <FavoriteBorderOutlinedIcon fontSize="large" style={{ color: '#b48a78' }} />,
    desc: 'Non-judgmental support, befriending, listening, and encouragement for wellbeing.',
    path: '/pastoral-care'
  },
];

function Programmes() {
  return (
    <>
      <Seo
        title="Programmes at the Vine Centre | Community Support Belfast"
        description="Explore the Vine Centre's programmes supporting families, youth, and the North Belfast community. Find out how to get involved."
      />
      <div className="programmes-root">
        <div className="programmes-hero">
        <h1>Our Programmes</h1>
        <p>Below are some of the programmes and services the Vine Centre offers. Click for more information or to get involved.</p>
      </div>
      <div className="programmes-grid">
        {programmes.map((prog, idx) => (
          <Link className="programme-card" key={idx} to={prog.path}>
            <div className="programme-icon">{prog.icon}</div>
            <div className="programme-title">{prog.name}</div>
            <div className="programme-desc">{prog.desc}</div>
          </Link>
        ))}
      </div>
      <style>{`
        .programmes-root {
          max-width: 1100px;
          margin: 0 auto;
          padding: 0 16px 48px 16px;
        }
        .programmes-hero {
          text-align: center;
          margin: 0 0 40px 0;
          padding: 40px 0 24px 0;
          background: linear-gradient(120deg, #f7e6ee 0%, #e6f7f2 100%);
          border-radius: 22px;
          box-shadow: 0 4px 24px rgba(123,30,58,0.10);
        }
        .programmes-hero h1 {
          color: #7b1e3a;
          font-weight: 900;
          font-size: 2.3rem;
          margin: 0 0 0.2em 0;
          letter-spacing: 1px;
        }
        .programmes-hero p {
          color: #3a6c5a;
          font-size: 1.13rem;
          margin: 0;
        }
        .programmes-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          gap: 2.2rem;
        }
        .programme-card {
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 2px 12px rgba(123,30,58,0.08);
          padding: 2.1rem 1.2rem 1.5rem 1.2rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          transition: box-shadow 0.18s, transform 0.18s;
          text-decoration: none;
        }
        .programme-card:hover {
          box-shadow: 0 8px 32px rgba(123,30,58,0.13);
          transform: translateY(-4px) scale(1.03);
        }
        .programme-icon {
          margin-bottom: 1.1rem;
        }
        .programme-title {
          font-size: 1.13rem;
          font-weight: 800;
          color: #7b1e3a;
          margin-bottom: 0.18em;
        }
        .programme-desc {
          font-size: 1.01rem;
          font-weight: 500;
          color: #3a6c5a;
        }
      `}</style>
    </div>
    </>
  );
}

export default Programmes;
